import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import OpenRotorMark from '@/components/base/OpenRotorMark';

export default function NotFound() {
  useEffect(() => {
    document.title = 'Page Not Found | NORTHLINE Flow Systems';
  }, []);
  return (
    <main className="min-h-screen bg-background-50 flex items-center justify-center px-5">
      <div className="text-center max-w-md">
        <Link to="/" className="inline-flex items-center gap-3 cursor-pointer">
          <OpenRotorMark size={40} title="NORTHLINE" />
          <span className="flex flex-col leading-none text-left">
            <span className="font-heading font-medium tracking-[0.14em] text-sm text-foreground-950">NORTHLINE</span>
            <span className="font-label text-[9px] tracking-[0.3em] text-foreground-500 mt-1">FLOW SYSTEMS</span>
          </span>
        </Link>
        <h1 className="mt-14 font-heading text-[96px] md:text-[128px] leading-none tracking-[-0.04em] text-foreground-950">404</h1>
        <p className="mt-6 t-body text-foreground-600">The page you&apos;re looking for doesn&apos;t exist or has been moved.</p>
        <div className="mt-10 flex flex-col sm:flex-row justify-center gap-3">
          <Link to="/" className="inline-flex justify-center items-center bg-primary-500 hover:bg-primary-600 text-foreground-50 font-label text-xs tracking-[0.12em] uppercase px-7 h-[52px] rounded-md transition-colors cursor-pointer whitespace-nowrap">Back to Home</Link>
          <Link to="/products" className="inline-flex justify-center items-center border border-foreground-950/70 text-foreground-950 hover:bg-foreground-950 hover:text-background-50 font-label text-xs tracking-[0.12em] uppercase px-7 h-[52px] rounded-md transition-colors cursor-pointer whitespace-nowrap">Browse Products</Link>
        </div>
      </div>
    </main>
  );
}